import { Avatar, Status, UserStatus } from "@chatscope/chat-ui-kit-react";
import { Image } from "react-img-placeholder";
import { HTMLAttributes } from "react";

export const AvatarWithPlaceholder = ({
	displayName,
	photoUri,
	placeholderUri,
	status,
	...rest
}: HTMLAttributes<HTMLDivElement> & {
	displayName?: string;
	photoUri?: string | null;
	placeholderUri?: string | null;
	status?: UserStatus;
	onClick?: () => void;
	size?: "xs" | "sm" | "md" | "lg" | "fluid";
}) => {
	return (
		<Avatar {...rest}>
			<Image
				title={displayName}
				alt={displayName}
				src={photoUri}
				placeholderSrc={placeholderUri ?? undefined}
			/>
			{typeof status === "string" && <Status status={status} size="md" />}
		</Avatar>
	);
};
